// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._404_root_mrl1h{height:calc(100vh - 130px);display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:1em}._404_h1_2w1Uc{font-size:260px;color:#cbced1;margin:0;height:140px}._404_not-found_y4BUJ{font-size:32px;color:#8391a2;margin-bottom:24px}._404_p_1zSKM{color:#8391a2;font-size:18px;margin:16px 0 0 0}._404_button_3HGmb{margin-top:32px}", ""]);
// Exports
exports.locals = {
	"root": "_404_root_mrl1h",
	"h1": "_404_h1_2w1Uc",
	"not-found": "_404_not-found_y4BUJ",
	"p": "_404_p_1zSKM",
	"button": "_404_button_3HGmb"
};
module.exports = exports;
